export const GET_PETITIONS_REQUEST = 'GET_PETITIONS_FOR_REVIEW_REQUEST';
export const GET_PETITIONS_SUCCESS = 'GET_PETITIONS_FOR_REVIEW_SUCCESS';
export const GET_PETITIONS_FAILURE = 'GET_PETITIONS_FOR_REVIEW_FAILURE';

export const SEND_DECISION_REQUEST = 'SEND_DECISION_REQUEST';
export const SEND_DECISION_SUCCESS = 'SEND_DECISION_SUCCESS';
export const SEND_DECISION_FAILURE = 'SEND_DECISION_FAILURE';

export const UPDATE_CATEGORIES_REQUEST = 'UPDATE_CATEGORIES_REQUEST';
export const UPDATE_CATEGORIES_SUCCESS = 'UPDATE_CATEGORIES_SUCCESS';
export const UPDATE_CATEGORIES_FAILURE = 'UPDATE_CATEGORIES_FAILURE';

export const SET_CURRENT_PETITION = 'SET_CURRENT_PETITION_FOR_REVIEW';
